import React from 'react';
import { RefinementList } from 'react-instantsearch';
import sortBy from 'lodash.sortby';

import FilterBlock from '../../elements/FilterBlock';
import { useScreenMinLg } from '@hooks/useResponsive';
import { HierarchicalMenuMulti } from '@search';

const sortItems = items => sortBy(items, ['label']);
const transformCountry = items => {
    const sorted = sortBy(items, ['label']);
    const usIndex = sorted.findIndex(item => item.label === 'United States');

    if (usIndex >= 0) {
        const usItem = sorted[usIndex];
        sorted.splice(usIndex, 1);
        sorted.unshift(usItem);
    }

    return sorted;
};

const MemberFilters = () => {
    const isScreenMinLg = useScreenMinLg();

    return (
        <>
            <FilterBlock label="Business Type" defaultExpanded={isScreenMinLg}>
                <div className="mb-3">
                    <HierarchicalMenuMulti attribute="business_type" limit={99999} transformItems={sortItems} />
                </div>
            </FilterBlock>

            <FilterBlock label="Country">
                <RefinementList attribute="location.country" limit={99999} transformItems={transformCountry} />
            </FilterBlock>

            <FilterBlock label="State/Province">
                <RefinementList attribute="location.state" limit={99999} transformItems={sortItems} />
            </FilterBlock>

            <FilterBlock label="Global Region">
                <RefinementList attribute="location.region" limit={99999} />
            </FilterBlock>

            <FilterBlock label="Business Responsibility">
                <RefinementList attribute="responsibility" limit={99999} />
            </FilterBlock>

            <FilterBlock label="Title Category">
                <RefinementList attribute="functional_title" limit={99999} />
            </FilterBlock>

            <FilterBlock label="Designation">
                <RefinementList attribute="designations.value" limit={99999} />
            </FilterBlock>
        </>
    );
};

export default MemberFilters;
